import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UsuarioService } from '../services/auth/usuario.service';
import { CustomMessageService } from '../services/utils/message.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private router: Router,
    private usuarioService: UsuarioService,
    private messageService: CustomMessageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // console.log('PASO POR EL GUARD AUTH');

    this.usuarioService.verificarCaducudadToken();

    let token = localStorage.getItem('token');
    let usuario = localStorage.getItem('usuario');

    if (state.url !== '/auth/login' && state.url !== '/') {
      sessionStorage.setItem('last_url', state.url);
    }

    if (token && usuario) {
      return true;
    } else {
      const oktaToken = this.obtenerTokenDelHash();

      if (oktaToken) {
        localStorage.setItem('token', oktaToken);
        localStorage.setItem('usuario', JSON.stringify(JSON.parse(atob(oktaToken!.split('.')[1]))['user']));

        // borrar el hash de la url
        window.location.hash = '';

        return true;
      }

      this.router.navigateByUrl('/auth/login');
      this.messageService.alert('Session expired');
      return false;
      // return true;
    }
  }

  /**
   * Extrae el token de Okta desde el hash de la URL.
   * El hash puede tener el formato #token=... o #/#token=...
   *
   * @returns {string | null} El token de Okta si existe, null en caso contrario
   */
  obtenerTokenDelHash(): string | null {
    let hash = window.location.hash.substring(1);

    // Removemos el '/' inicial si existe
    if (hash.startsWith('/')) {
      hash = hash.substring(1);
    }

    // Removemos el '#' inicial si todavía existe
    if (hash.startsWith('#')) {
      hash = hash.substring(1);
    }

    console.log('hashLimpio', hash);

    // Intentamos parsear como URLSearchParams
    try {
      const params = new URLSearchParams(hash);
      console.log('params', params);
      console.log('params.get("token")', params.get('token'));

      console.log('usuario', JSON.parse(atob(params.get('token')!.split('.')[1]))['user']);

      return params.get('token');
    } catch (error) {
      // Si falla el parsing, intentamos extraer el token manualmente usando regex
      const match = hash.match(/token=([^&]+)/);
      return match ? match[1] : null;
    }
  }
}
